import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Ripple from '@/components/Ripple'
import { CardActionType, type CardActionItem } from '../../types'

interface CardActionsProps {
  onActionClick: (actionType: CardActionType) => void
}

export default React.memo(function CardActions({ onActionClick }: CardActionsProps) {
  const { t } = useTranslation()

  const cardActionItems = useMemo<CardActionItem[]>(
    () => ([
      { icon: "/icon/card-info.svg", title: t("信息"), actionType: CardActionType.CardInfo },
      { icon: "/icon/card-freeze.svg", title: t("冻结或解冻"), actionType: CardActionType.FreezeUnfreeze },
      { icon: "/icon/card-limit.svg", title: t("限额"), actionType: CardActionType.LimitAdjustment },
      { icon: "/icon/card-set.svg", title: t("管理"), actionType: CardActionType.Management },
    ]),
    [t]
  )

  return (
    <div className="flex justify-between items-start mt-5">
      {cardActionItems.map(item => (
        <Ripple key={item.title} className="rounded-2 flex-1 py-1">
          <div 
            onClick={() => onActionClick(item.actionType)} 
            className="flex flex-col items-center"
          >
            <div className="w-15 h-15 rounded-full bg-[#E9E9E9]/35 border-[0.5px] border-[#808080] flex items-center justify-center">
              <img src={item.icon} alt={item.title} />
            </div>
            <div className="text-[#1A1A1A] text-3 text-center mt-4 break-all">{item.title}</div>
          </div>
        </Ripple>
      ))}
    </div>
  )
})
